export default {
  login: {
    title: "登录",
    componentPath: "login/Login"
  },
  phoneRegister: {
    title: "手机注册",
    componentPath: "registered/MobilePhone"
  },
  registered: {
    title: "注册",
    componentPath: "registered/Registered"
  },
  findPassword: {
    title: "找回密码",
    componentPath: "FindPassword"
  },
  findAccount: {
    title: "找回账号",
    componentPath: "FindAccount"
  }
};
